import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import {
  Route as pathlessAuthenticatedRoute,
  requireAdminOrPermission,
} from '../../route';
import { AppPage } from './AppPage';

/** `/apps/$appId` — one App, rendered from its active version. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/apps/$appId',
  component: AppPage,
  loader: () => ({
    crumb: msg('App', { context: 'page breadcrumb for a single App' }),
  }),
  beforeLoad: async ({ context }) => {
    await requireAdminOrPermission({
      context,
      action: Action.Read,
      subject: Subject.App,
    });
  },
});
